<template>
  <div class="pr-2">
    <highcharts :options="chartOptions" ref="lineCharts"></highcharts>
    <v-divider></v-divider>
    <div>
      <template>
        <v-row justify="center">
          <v-col cols="4" class="ml-2">
            <v-autocomplete
              ref="service_id_value"
              v-model="filters.service_id_value"
              :items="analisisArray"
              label="Seleccione un Analisis"
              outlined
              :item-text="customTextAnalisis"
              item-value="id"
              clearable
              :value="filters.service_id_value"
              :loading="isLoading"
              v-on:keyup.enter="searchAnalisis($event)"
              hide-details="auto"
              required
            ></v-autocomplete>
          </v-col>
          <v-col cols="2" class="pt-4">
            <v-select
              v-model="filters.type_value"
              :items="list_type"
              outlined
              label="Tipo"
              hide-details="auto"
              :item-text="customText"
              item-value="id"
            ></v-select>
          </v-col>
          <v-col cols="2" class="pt-4" v-if="filters.type_value != 'year'">
            <v-select
              v-model="filters.year_value"
              :items="list_years"
              outlined
              label="Año"
              hide-details="auto"
            ></v-select>
          </v-col>
          <v-col
            cols="3"
            class="pt-4"
            v-if="
              filters.type_value != 'biannual' && filters.type_value != 'year'
            "
          >
            <v-select
              v-model="filters.month_value"
              :items="list_months"
              item-value="id"
              outlined
              label="Mes"
              hide-details="auto"
            ></v-select>
          </v-col>
          <v-col cols="3" class="pt-4" v-if="filters.type_value == 'biannual'">
            <v-select
              v-model="filters.semestre_value"
              :items="list_semestre"
              outlined
              label="Semestre"
              :item-text="customText"
              item-value="id"
              hide-details="auto"
            ></v-select>
          </v-col>
          <v-col
            cols="3"
            class="pt-4"
            v-if="filters.type_value == 'week' || filters.type_value == 'diary'"
          >
            <v-select
              v-model="filters.week_value"
              :items="list_week"
              outlined
              label="Semana"
              :item-text="customText"
              item-value="id"
              hide-details="auto"
            ></v-select>
          </v-col>
          <v-col cols="3" class="pt-4" v-if="filters.type_value == 'diary'">
            <v-select
              v-model="filters.diary_value"
              :items="list_diary"
              outlined
              label="Dia"
              :item-text="customText"
              item-value="id"
              hide-details="auto"
            ></v-select>
          </v-col>
          <v-col cols="3" class="pt-4">
            <v-btn color="indigo" dark @click="handleUpdateChart">
              <v-icon size="14" class="mr-1">
                fas fa-redo-alt
              </v-icon>
              Actualizar
            </v-btn>
          </v-col>
        </v-row>
      </template>
    </div>
  </div>
</template>

<script>
import { Chart } from "highcharts-vue";
import { mapActions, mapState } from "vuex";
import DashboardApi from "../../../apis/Dashboard";
import Tools from "../../../helpers/Tools";
import { generateColor } from "../../../helpers/GenerateColor/generateColor";

export default {
  name: "ProductsChart",
  components: {
    highcharts: Chart,
  },
  data() {
    return {
      dataReport: [],
      categories: [],
      dataValues: [],
      list_years: [],
      list_type: [
        { id: "year", name: "Anual" },
        { id: "biannual", name: "Semestre" },
        { id: "month", name: "Mensual" },
        { id: "week", name: "Semanal" },
        { id: "diary", name: "Diarias" },
      ],
      list_semestre: [
        { id: "Semestre 1 - ", name: "Semestre 1" },
        { id: "Semestre 2 - ", name: "Semestre 2" },
      ],
      list_week: [
        { id: "1", name: "Semana 1" },
        { id: "2", name: "Semana 2" },
        { id: "3", name: "Semana 3" },
        { id: "4", name: "Semana 4" },
        { id: "5", name: "Semana 5" },
      ],
      list_diary: [
        { id: "Lunes", name: "Lunes" },
        { id: "Martes", name: "Martes" },
        { id: "Miercoles", name: "Miercoles" },
        { id: "Jueves", name: "Jueves" },
        { id: "Viernes", name: "Viernes" },
        { id: "Sabado", name: "Sabado" },
        { id: "Domingo", name: "Domingo" },
      ],
      list_months: [],
      filters: {
        year_value: this.$moment().year(),
        month_value: this.$moment().month() + 1,
        type_value: "year",
        semestre_value: "Semestre 1 - ",
        week_value: "1",
        diary_value: "Lunes",
        service_id_value: null,
      },
      chartOptions: {
        chart: {
          type: "column",
        },
        title: {
          text: "Ventas por mes",
        },
        xAxis: {
          categories: [],
          crosshair: true,
        },
        yAxis: {
          min: 0,
          title: {
            text: "Cantidad",
          },
        },
        plotOptions: {
          column: {
            pointPadding: 0.2,
            borderWidth: 0,
          },
        },
        credits: {
          enabled: false,
        },
        series: [],
      },
      isLoading: false,
    };
  },
  computed: {
    ...mapState("analysis", ["analisisArray", "paginated"]),
  },
  methods: {
    ...mapActions("analysis", ["getAnalysis"]),
    customText(item) {
      let text = item.name;

      return text;
    },
    customTextAnalisis(item) {
      let text = item.name;

      return text;
    },
    getAmountByAnalisys() {
      DashboardApi.getAmountByAnalisys({
        year_value: this.filters.year_value,
        month_value: this.filters.month_value,
        type_value: this.filters.type_value,
        service_id_value: this.filters.service_id_value,
        week_value: this.filters.week_value,
      })
        .then((response) => {
          this.dataReport = response.data;
          this.prepareData();
        })
        .catch((error) => {
          console.log("Ocurrió un error");
        });
    },
    prepareData() {
      let analisys = [];
      let values = [];

      this.dataReport.forEach((element, index) => {
        if (this.filters.type_value == "year") {
          if (element.name == this.filters.year_value.toString()) {
            analisys = [];
            values = [];
            element.value.map((dt, i) => {
              analisys.push(dt.name);
              let itemValue = {
                color: generateColor(),
                y: parseFloat(dt.sale_amount),
              };
              values.push(itemValue);
            });
          }
        } else if (this.filters.type_value == "biannual") {
          if (
            element.name ==
            this.filters.semestre_value.toString() +
              this.filters.year_value.toString()
          ) {
            analisys = [];
            values = [];
            element.value.map((dt, i) => {
              analisys.push(dt.name);
              let itemValue = {
                color: generateColor(),
                y: parseFloat(dt.sale_amount),
              };
              values.push(itemValue);
            });
          }
        } else if (this.filters.type_value == "month") {
          if (element.name == this.getMonthName(this.filters.month_value)) {
            analisys = [];
            values = [];
            element.value.map((dt, i) => {
              analisys.push(dt.name);
              let itemValue = {
                color: generateColor(),
                y: parseFloat(dt.sale_amount),
              };
              values.push(itemValue);
            });
          }
        } else if (this.filters.type_value == "week") {
          if (
            element.name ==
            this.list_week.find((dt) => dt.id == this.filters.week_value)?.name
          ) {
            analisys = [];
            values = [];
            element.value.map((dt, i) => {
              analisys.push(dt.name);
              let itemValue = {
                color: generateColor(),
                y: parseFloat(dt.sale_amount),
              };
              values.push(itemValue);
            });
          }
        } else if (this.filters.type_value == "diary") {
          if (element.name == this.filters.diary_value) {
            analisys = [];
            values = [];
            element.value.map((dt, i) => {
              analisys.push(dt.name);
              let itemValue = {
                color: generateColor(),
                y: parseFloat(dt.sale_amount),
              };
              values.push(itemValue);
            });
          }
        }
      });

      let valueSeries = [];
      valueSeries.push({
        name: "",
        data: values,
      });
      this.chartOptions.xAxis.categories = analisys;
      this.chartOptions.series = valueSeries;
    },
    getMonthName(number_month) {
      let names = [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre",
      ];

      return names[number_month - 1];
    },
    generateListYears() {
      this.list_years = [];
      let start_year = 2022;
      let end_year = this.$moment().year();
      for (let i = start_year; i <= end_year; i++) {
        this.list_years.push(i);
      }
    },
    handleUpdateChart() {
      let month_name = this.getMonthName(this.filters.month_value);
      this.handleChangeTitle();
      this.getAmountByAnalisys();
    },
    handleChangeTitle() {
      if (this.filters.type_value == "year") {
        this.chartOptions.title.text =
          "Cantidad de Análisis del " + this.filters.year_value;
      } else if (this.filters.type_value == "biannual") {
        this.chartOptions.title.text = `Cantidad de Análisis del ${this.filters.semestre_value} ${this.filters.year_value} `;
      } else if (this.filters.type_value == "month") {
        this.chartOptions.title.text = `Cantidad de Análisis del ${
          this.filters.year_value
        } - ${this.getMonthName(this.filters.month_value)}`;
      } else if (this.filters.type_value == "week") {
        this.chartOptions.title.text = `Cantidad de Análisis del ${
          this.filters.year_value
        } - ${this.getMonthName(this.filters.month_value)} - ${
          this.filters.week_value
        }`;
      } else if (this.filters.type_value == "diary") {
        // this.chartOptions.title.text = `Cantidad de Análisis - ${this.filters.diary_value}`;
        this.chartOptions.title.text = `Cantidad de Análisis - ${this.getMonthName(
          this.filters.month_value
        )} - ${
          this.list_week.find((dt) => dt.id == this.filters.week_value)?.name
        } - ${this.filters.diary_value}`;
      }
    },
    loadData() {
      this.list_months = Tools.getMonths();
      this.generateListYears();
      let month_name = this.getMonthName(this.filters.month_value);
      this.handleChangeTitle();
      this.getAmountByAnalisys();
      this.searchAnalisis();
    },
    async searchAnalisis(event) {
      this.isLoading = true;
      if (event) {
        const value = event.target.value;
        if (value.length > 0) {
          await this.getAnalysis({ name: value });
        } else {
          await this.getAnalysis({});
        }
      } else {
        await this.getAnalysis({});
      }
      this.isLoading = false;
    },
  },
  created() {
    this.loadData();
  },
};
</script>

<style scoped></style>
